<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-80 md-xsmall-size-80 mx-auto">
      <simple-wizard>
        <template slot="header">
          <h3 class="title">Create University</h3>
        </template>

        <wizard-tab :before-change="() => validateStep('step1')">
          <template slot="label">
            University
          </template>
          <first-step ref="step1" @on-validated="firstStep"></first-step>
        </wizard-tab>
      </simple-wizard>
    </div>
  </div>
</template>
<script>
import FirstStep from "./UniversityCreateSteps/FirstStep.vue";
import Swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "@/components";

export default {
  data() {
    return {
      wizardModel: {}
    };
  },
  components: {
    FirstStep,
    SimpleWizard,
    WizardTab
  },
  methods: {
    validateStep(ref) {
      if (!this.$refs["step1"].logo) {
        this.$notify({
          message: "Logo is required.",
          icon: "add_alert",
          type: "warning",
          verticalAlign: "top",
          timeout: 3000
        });
        this.$refs[ref].validate();
        return false;
      }
      return this.$refs[ref].validate();
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    getfirstStepData() {
      let data = {
        name: this.$refs["step1"].name,
        address: this.$refs["step1"].address,
        rank: this.$refs["step1"].rank,
        website: this.$refs["step1"].website,
        type: this.$refs["step1"].type,
        city: this.$refs["step1"].city,
        logo: this.$refs["step1"].logo,
        order: this.$refs["step1"].order,
        about: this.$refs["step1"].about,
        history: this.$refs["step1"].history,
        our_mission: this.$refs["step1"].our_mission,
        values: this.$refs["step1"].values,
        campus_life: this.$refs["step1"].campus_life,
        year_of_foundation: this.$refs["step1"].year_of_foundation,
        campus_number: this.$refs["step1"].campus_number,
        faculties_number: this.$refs["step1"].faculties_number,
        associate_programs_number: this.$refs["step1"].associate_programs_number,
        bachelor_programs_number: this.$refs["step1"].bachelor_programs_number,
        master_programs_number: this.$refs["step1"].master_programs_number,
        phd_programs_number: this.$refs["step1"].phd_programs_number,
        students_number: this.$refs["step1"].students_number,
        alumni_number: this.$refs["step1"].alumni_number,
        acceptance_rate_percent: this.$refs["step1"].acceptance_rate_percent,
        partners_number: this.$refs["step1"].partners_number,
        academic_employee_number: this.$refs["step1"].academic_employee_number,
        research_centers_number: this.$refs["step1"].research_centers_number,
        kdv: this.$refs["step1"].kdv,
        gv: this.$refs["step1"].gv,
        contract: this.$refs["step1"].contract,
        status: this.$refs["step1"].status
      };
      var post_data = {};
      for (const field in data) {
        if (
          data[field] === null ||
          data[field] === undefined ||
          data[field] === ""
        ) {
          continue;
        }
        if (this.$refs["step1"][field] instanceof Date) {
            post_data[field] = this.$refs["step1"][field]
              .toLocaleDateString("ko-KR")
              .replaceAll(". ", "-")
              .replaceAll(".", "");
          } else {
            post_data[field] = this.$refs["step1"][field];
          }
      }
      post_data.main_photo = this.$refs["step1"].main_photo_image
      return post_data;
    },
    firstStep(validated, model) {
      if (validated) {
        let data = this.getfirstStepData();
        this.$store
          .upsertUniversity(data)
          .then(response => {
            this.wizardComplete();
          })
          .catch(error => {
            var message = error.response.data;
            this.$notify({
              message: JSON.stringify(message),
              icon: "add_alert",
              type: "warning",
              verticalAlign: "top",
              timeout: 5000
            });
          });
      }
      this.wizardModel = { ...this.wizardModel, ...model };
      return validated;
    },
    wizardComplete() {
      Swal.fire({
        title: "University created.",
        text: "Finish",
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      }).then(result => {
        this.$router.push({ name: "University List" });
      });
    }
  }
};
</script>
